import React, { PureComponent } from 'react';

import { Dropzone } from 'components/dropzone';
import { I18n } from 'components/translate';
import { formatBytes } from 'helpers/File';
import PropTypes from 'prop-types';

import { UploadConsumer, UploadProptypes } from '@hotmart/club-files-ui';

@UploadConsumer()
export default class FileImageUpload extends PureComponent {
  static propTypes = {
    maxFileSize: PropTypes.number,
    sendFiles: PropTypes.func,
    beforeSend: PropTypes.func,
    multiple: PropTypes.bool,
    isConfigLoaded: PropTypes.bool,
    fileUpload: UploadProptypes.fileUpload
  };

  static defaultProps = {
    multiple: true
  };

  get fileUpload() {
    return this.props.fileUpload;
  }

  updateItem = (items) => {
    const { beforeSend } = this.props;
    const {
      sendMultiples,
      delete: deleteAction,
      send
    } = this.fileUpload ? this.fileUpload.actions : {};

    beforeSend
      ? beforeSend(sendMultiples, items, deleteAction)
      : send && send(items);
  };

  render() {
    const { multiple } = this.props;

    return (
      <Dropzone
        onDrop={this.updateItem}
        multiple={multiple}
        isLoaded={this.props.isConfigLoaded}
      >
        <div className="dropzone__info">
          <div className="dropzone__info__label">
            <label>
              <I18n html label="files.image.extensions" />
            </label>
            <label>
              <I18n
                html
                label="files.image.resolution"
                data={{
                  width: 800,
                  height: 800,
                  size: formatBytes(this.props.maxFileSize)
                }}
              />
            </label>
          </div>
          <div className="dropzone__action__button">
            <button className="hot-button hot-button--secondary">
              <I18n html label="files.image.insert_image" />
            </button>
          </div>
        </div>
      </Dropzone>
    );
  }
}
